import { claimStates, claimTypes } from "../objects/Claim";
import { certificationStates, remunerationTypes } from "../objects/Payslip";

/**
 * @param {number} minutes
 */
export function formatDurationMinutes(minutes) {
    if (minutes < 0) {
        return '-' + formatDurationMinutes(-minutes);
    }

    const hours = Math.floor(minutes / 60);
    const mins = Math.floor(minutes % 60);

    if (hours > 0 && minutes > 0) {
        return `${hours} tim ${mins} min`;
    }

    if (hours > 0) {
        return `${hours} tim`;
    }

    return `${mins} min`;
}


/**
 * @param {number} claimType
 */
export function getClaimTypeText(claimType) {
    switch (claimType) {
        case claimTypes.legacyTravel: return 'Reseersättning';
        case claimTypes.travel: return 'Km-ersättning';
        case claimTypes.parking: return 'Parkeringsavgift';
        case claimTypes.congestion: return 'Trängselskatt';
        case claimTypes.publicTransport: return 'Kollektivtrafik';
        case claimTypes.travelTime: return 'Restid';
        case claimTypes.expense: return 'Utlägg';
        case claimTypes.adjuster: return 'Justeringsarvode';
        case claimTypes.lostIncomeAmount:
        case claimTypes.lostIncomeNumber:
        case claimTypes.lostIncomeRate:
            return 'Förlorad inkomst';
        default:
            return 'Okänt';
    }
}

/**
 * @param {number} claimType
 */
export function getClaimStateText(state) {
    switch (state) {
        case claimStates.created: return 'Ej rapporterad';
        case claimStates.reported: return 'Rapporterad';
        case claimStates.rejected: return 'Avslagen';
        case claimStates.accepted: return 'Godkänd';
        default: return 'Okänd';
    }
}

/**
 * 
 * @param {number} remunerationType 
 * @param {number?} claimType 
 */
export function getRemunerationTitle(remunerationType, claimType) {
    switch (remunerationType) {
        case remunerationTypes.claim:
            return 'Troman Politiker - ' + (claimType != null ? getClaimTypeText(claimType) : 'Anspråk');
        case remunerationTypes.calculatedMeeting:
            return 'Beräknat mötesarvode';
        case remunerationTypes.calculatedTravel:
            return 'Beräknad km-ersättning';
        case remunerationTypes.payment:
            return 'Övrig ersättning';
        default:
            return 'Okänt';
    }
}

/**
 * 
 * @param {number} certificationState
 */
export function getCertificationState(certificationState) {
    switch (certificationState) {
        case certificationStates.skipped: return 'Attesteras inte';
        case certificationStates.pending: return 'Väntar på attest';
        case certificationStates.rejected: return 'Avslaget vid attest';
        case certificationStates.certified: return 'Attesterad';
        case certificationStates.recalled: return 'Återkallad';
    }
}

/**
 * 
 * @param {number} certificationState
 */
export function getCertificationStateSubtitle(certificationState) {
    switch (certificationState) {
        case certificationStates.pending: return 'väntar på attest';
        case certificationStates.rejected: return 'attest avslagen';
        case certificationStates.recalled: return 'återkallad';
    }
}